// Link previews come in English and French. Scrapers never send the viewer's
// language, so a shared link carries the sharer's: ?lang=fr picks the French
// card on the server (server/app.js).
export const withShareLang = (url, language) => {
  const u = new URL(url);
  if (String(language || '').startsWith('fr')) u.searchParams.set('lang', 'fr');
  else u.searchParams.delete('lang');
  return u.toString();
};
